'use strict';

var UserManagementManageUsersController = function UserManagementManageUsersController($scope, dataRetrieverService, userManagementConstants, userSecureService, userManagementUsersService) {
  $scope.userManagementState = 'default';
  $scope.selectedUser = null;
  dataRetrieverService.getDataRetriever('USER_MANAGEMENT_SCREEN', 'user-management-manage-users-mode').setCustomSearchCriteriaRules(userManagementUsersService.getUserSearchCriteria());
  $scope.showUserProfile = function (selectedUser) {
    userSecureService.retrieveSpecifiedUser(selectedUser[0].userId).then(function (userData) {
      $scope.userData = userData;
      $scope.userManagementState = userManagementConstants.MANAGE_USERS_SCREENS.USER_PROFILE;
    });
  };
  $scope.$on('user-management-manage-users:change-screen', function onChangeScreen(event, value) {
    $scope.userManagementState = value;
  });
  $scope.backToUserList = function () {
    $scope.$emit('user-management-manage-users:change-screen', userManagementConstants.SCREEN_VALUE.MANAGE_USERS);
  };
  $scope.buttonText = 'Manage access requests';
  $scope.destScreen = userManagementConstants.MANAGE_USERS_SCREENS.MANAGE_ACCESS_REQUESTS;
};
UserManagementManageUsersController.$inject = ['$scope', 'DataRetrieverService', 'UserManagementConstants', 'UserSecureService', 'UserManagementUsersService'];
module.exports = UserManagementManageUsersController;